import {
    gsap
} from 'gsap'
import {
    ScrollTrigger
} from "gsap/ScrollTrigger";
import{
    ScrollToPlugin
} from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollTrigger,ScrollToPlugin)

//header color change

function colorChange() {
    let mobile
    mobile = false;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    if (isMobile) {
        mobile = true
    } else {
        mobile = false
    }
    if (isMobile == false) {
        gsap.to(".l-header-container__menu", {
            scrollTrigger: {
                start: () => innerHeight,
                end: () => innerHeight * 1.6,
                scrub: true,
                // toggleActions:"restart pause resume none",
            },
            opacity:0,
        })
        gsap.to(".c-btn-cta", {
            scrollTrigger: {
                trigger:"#entry",
                start:"top top",
                end:"+=200px",
                scrub: true,
                toggleActions:"restart pause resume none",
                ease:"power1.out",
            },
            opacity:0,
        })
        gsap.to(".l-header-container__cta-sns", {
            scrollTrigger: {
                trigger:"#entry",
                start:"top top",
                end:"+=200px",
                scrub: true,
                toggleActions:"restart pause resume none",
                ease:"power1.out",
            },
            x:"260px",
        })
        gsap.to("#mainCta", {
            scrollTrigger: {
                trigger:"#entry",
                start:"top top",
                end:"+=100px",
                scrub: true,
                toggleActions:"restart pause resume none",
                ease:"power1.out",
            },
            opacity:0,
        })
    } 
}

//sp navigation
function spNav() {
    const navBtn = document.querySelector('.l-nav-btn')
    const navBody = document.querySelector('.l-nav-sp')
    const menuItem = document.querySelectorAll('.l-nav-sp__item')
    const t1 = gsap.timeline()
    t1.fromTo(navBody, {
        right: '-100%',
        opacity: 0,
    }, {
        right: 0,
        opacity: 1,
    })

    t1.reverse()

    navBtn.addEventListener('click', () => {

        t1.reversed(!t1.reversed())

    },{passive:true})
    for (const item of menuItem) {
        item.addEventListener('click', () => {
            t1.reversed(!t1.reversed())
        },{passive:true})
    }
}

//hyperlink scroll smoothing and onhover color change
function smoothScroll() {
    const navLinks = document.querySelectorAll(".l-nav__item > a")
    
    navLinks.forEach((navLink) => {     
            if (
                navLink.hasAttribute("href") &&
                navLink.getAttribute("href").startsWith("#")
            ) {
                //link-color-change
                navLink.addEventListener('mouseenter',()=>{
                    gsap.to(navLink,.6,{
                        opacity:.4
                    })
                },{passive:true})
                navLink.addEventListener('mouseleave',()=>{
                    gsap.to(navLink,.6,{
                        opacity:1
                    })
                },{passive:true})
                //hyperlink
                navLink.addEventListener("click", () => {
                    gsap.to(window, {
                        duration: .4,
                        ease: "power2.easeIn",
                        scrollTo: {
                            y: navLink.getAttribute("href") ,
                            offsetY: 200,
                        }
                    })
                },{passive:true})
            }
    })
}

function backtoTop(){
    const backBtn = document.querySelector('.c-btn-top')
    backBtn.addEventListener('mouseenter',() =>{
        gsap.to(backBtn,.6,{
            y:"-24px",
            ease:"expo.out"
        })
    },{passive:true})
    backBtn.addEventListener('mouseleave',() =>{
        gsap.to(backBtn,.6,{
            y:"0",
            ease:"expo.out"
        })
    },{passive:true})
    backBtn.addEventListener('click',()=>{
        gsap.to(window,1,{
            scrollTo:{
                y:0,
                ease:"Expo.easeInout"}
        })
    },{passive:true})
}

//news-nav arrow-movement
function accordion(){

// 要素をスライドしながら非表示にする関数(jQueryのslideUpと同じ)
const slideUp = (el, duration = 300) => {
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("padding-top");
      el.style.removeProperty("padding-bottom");
      el.style.removeProperty("margin-top");
      el.style.removeProperty("margin-bottom");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
      el.classList.remove("is-open");
    }, duration);
  };
  
  // 要素をスライドしながら表示する関数(jQueryのslideDownと同じ)
  const slideDown = (el, duration = 300) => {
    el.classList.add("is-open");
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") {
      display = "block";
    }
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.height = height + "px";
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  };
  
  // 要素をスライドしながら交互に表示/非表示にする関数(jQueryのslideToggleと同じ)
  const slideToggle = (el, duration = 300) => {
    if (window.getComputedStyle(el).display === "none") {
      return slideDown(el, duration);
    } else {
      return slideUp(el, duration);
    }
  };
  
  /* =================================================== */
  // DOM操作
  /* =================================================== */
  
  // アコーディオンを全て取得
  const accordions = document.querySelectorAll(".js-accordion");
  // 取得したアコーディオンをArrayに変換(IE対策)
  const accordionsArr = Array.prototype.slice.call(accordions);
  
  accordionsArr.forEach((accordion) => {
    // Triggerを全て取得
    const accordionTriggers = accordion.querySelectorAll(".js-accordion-trigger");
    // TriggerをArrayに変換(IE対策)
    const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);
  
    accordionTriggersArr.forEach((trigger) => {
      // Triggerにクリックイベントを付与
      trigger.addEventListener("click", (e) => {
        accordionTriggersArr.forEach((trigger) => {
          // クリックしたアコーディオン以外を全て閉じる
          if (trigger !== e.target.parentElement) {
            trigger.classList.remove("is-active");
            const openedContent = trigger.querySelector(".accordion__content");
            slideUp(openedContent);
          }
        });
  
        // '.is-active'クラスを付与or削除
        trigger.classList.toggle("is-active");
        // 開閉させる要素を取得
        const content = trigger.querySelector(".accordion__content");
        // 要素を展開or閉じる
        slideToggle(content);
      });
    });
  });
}
export {
    colorChange,
    spNav,
    smoothScroll,
    backtoTop,
    accordion
}